import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "להודות באמת: קשה לי לבקש",
    opening: localizedGenderNode(
      [
      "היום אני מפסיק להגיד לעצמי “זה לא חשוב”. אני מודה: קשה לי לבטא מה אני בוחר/ת."
    ],
      [
      "היום אני מפסיק להגיד לעצמי “זה לא חשוב”. אני מודה: קשה לי לבטא מה אני בוחר/ת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית.",
      "אני אומר לעצמי בלב: “הקושי הזה מנסה להגן עליי.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית.",
      "אני אומר לעצמי בלב: “הקושי הזה מנסה להגן עליי.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה קשה לי לבקש בקשר הזה?\n[כאן אני כותב]",
      "מה אני מפחד שיקרה אם אבקש את זה?\n[כאן אני כותב]",
      "איפה בגוף אני מרגיש את הפחד הזה?\n[כאן אני כותב]"
    ],
      [
      "מה קשה לי לבקש בקשר הזה?\n[כאן אני כותב]",
      "מה אני מפחד שיקרה אם אבקש את זה?\n[כאן אני כותב]",
      "איפה בגוף אני מרגיש את הפחד הזה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "קושי לבקש הוא סימן לרגישות — לא לחולשה."
    ],
      [
      "סגירה",
      "קושי לבקש הוא סימן לרגישות — לא לחולשה."
    ]
    ),
    action: localizedGenderNode(
      "אני מזהה צורך אחד שלי — בלי לבטא אותו עדיין. רק שם לב.",
      "אני מזהה צורך אחד שלי — בלי לבטא אותו עדיין. רק שם לב."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "מה למדתי בעבר על בקשות",
    opening: localizedGenderNode(
      [
      "היום אני מבין מאיפה זה בא, בלי להאשים."
    ],
      [
      "היום אני מבין מאיפה זה בא, בלי להאשים."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “זה נלמד — זה לא מי שאני.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “זה נלמד — זה לא מי שאני.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה קרה בעבר כשביקשתי משהו חשוב?\n[כאן אני כותב]",
      "איזה מסר לקחתי מזה על בקשות וגבולות?\n[כאן אני כותב]",
      "איזו אמת עדינה יכולה להתקיים היום, גם אם העבר היה קשה?\n[כאן אני כותב]"
    ],
      [
      "מה קרה בעבר כשביקשתי משהו חשוב?\n[כאן אני כותב]",
      "איזה מסר לקחתי מזה על בקשות וגבולות?\n[כאן אני כותב]",
      "איזו אמת עדינה יכולה להתקיים היום, גם אם העבר היה קשה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "העבר מסביר אותי — הוא לא רוצה לנהל אותי."
    ],
      [
      "סגירה",
      "העבר מסביר אותי — הוא לא רוצה לנהל אותי."
    ]
    ),
    action: localizedGenderNode(
      "כשעולה מחשבה “עדיף לשתוק” — נשימה אחת + “זה ישן”.",
      "כשעולה מחשבה “עדיף לשתוק” — נשימה אחת + “זה ישן”."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "הפחד להיות “יותר מדי”",
    opening: localizedGenderNode(
      [
      "היום אני פוגש את הפחד להיות נטל."
    ],
      [
      "היום אני פוגש את הפחד להיות נטל."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי אני מרגיש שאני “יותר מדי”?\n[כאן אני כותב]",
      "מה אני עושה עם הצרכים שלי ברגע הזה?\n[כאן אני כותב]",
      "אם חבר היה מרגיש כך — מה הייתי אומר לו?\n[כאן אני כותב]"
    ],
      [
      "מתי אני מרגיש שאני “יותר מדי”?\n[כאן אני כותב]",
      "מה אני עושה עם הצרכים שלי ברגע הזה?\n[כאן אני כותב]",
      "אם חבר היה מרגיש כך — מה הייתי אומר לו?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "צורך לא הופך אותי לנטל. הוא הופך אותי לאנושי."
    ],
      [
      "סגירה",
      "צורך לא הופך אותי לנטל. הוא הופך אותי לאנושי."
    ]
    ),
    action: localizedGenderNode(
      "אני אומר לעצמי משפט אחד שמכבד צורך.",
      "אני אומר לעצמי משפט אחד שמכבד צורך."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "שתיקה כהרגל",
    opening: localizedGenderNode(
      [
      "היום אני רואה איך שתיקה מגינה — ואיך היא פוגעת."
    ],
      [
      "היום אני רואה איך שתיקה מגינה — ואיך היא פוגעת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי אני שותק במקום לדבר?\n[כאן אני כותב]",
      "מה אני מרוויח מהשתיקה בטווח הקצר?\n[כאן אני כותב]",
      "ומה המחיר בטווח הארוך?\n[כאן אני כותב]"
    ],
      [
      "מתי אני שותק במקום לדבר?\n[כאן אני כותב]",
      "מה אני מרוויח מהשתיקה בטווח הקצר?\n[כאן אני כותב]",
      "ומה המחיר בטווח הארוך?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "שתיקה מגינה רגע — אבל גובה מחיר מתמשך."
    ],
      [
      "סגירה",
      "שתיקה מגינה רגע — אבל גובה מחיר מתמשך."
    ]
    ),
    action: localizedGenderNode(
      "אני מזהה רגע אחד של שתיקה — ולא שופט.",
      "אני מזהה רגע אחד של שתיקה — ולא שופט."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "גבול זה לא איום",
    opening: localizedGenderNode(
      [
      "היום אני לומד שגבול אינו התקפה."
    ],
      [
      "היום אני לומד שגבול אינו התקפה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “גבול שומר על קשר — לא הורס אותו.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “גבול שומר על קשר — לא הורס אותו.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה גבול קשה לי במיוחד להציב?\n[כאן אני כותב]",
      "מה אני מפחד שיקרה אם אציב אותו?\n[כאן אני כותב]",
      "איך נראה גבול רך ולא תוקפני?\n[כאן אני כותב]"
    ],
      [
      "איזה גבול קשה לי במיוחד להציב?\n[כאן אני כותב]",
      "מה אני מפחד שיקרה אם אציב אותו?\n[כאן אני כותב]",
      "איך נראה גבול רך ולא תוקפני?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "גבול הוא מידע — לא אולטימטום."
    ],
      [
      "סגירה",
      "גבול הוא מידע — לא אולטימטום."
    ]
    ),
    action: localizedGenderNode(
      "אני מנסח גבול אחד לעצמי, בכתב בלבד.",
      "אני מנסח גבול אחד לעצמי, בכתב בלבד."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "להבדיל בין בקשה לדרישה",
    opening: localizedGenderNode(
      [
      "היום אני לומד לבקש בלי לשלוט."
    ],
      [
      "היום אני לומד לבקש בלי לשלוט."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך נשמעת בקשה כשאני בלחץ?\n[כאן אני כותב]",
      "איך נשמעת בקשה כשאני רגוע?\n[כאן אני כותב]",
      "איזו גרסה מקרבת יותר?\n[כאן אני כותב]"
    ],
      [
      "איך נשמעת בקשה כשאני בלחץ?\n[כאן אני כותב]",
      "איך נשמעת בקשה כשאני רגוע?\n[כאן אני כותב]",
      "איזו גרסה מקרבת יותר?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "בקשה מאפשרת בחירה. דרישה יוצרת פחד."
    ],
      [
      "סגירה",
      "בקשה מאפשרת בחירה. דרישה יוצרת פחד."
    ]
    ),
    action: localizedGenderNode(
      "אני מתרגל ניסוח בקשה רגועה לעצמי.",
      "אני מתרגל ניסוח בקשה רגועה לעצמי."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "מה קורה בי כשלא מקשיבים לי",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב לפגיעה בלי להקטין אותה."
    ],
      [
      "היום אני מקשיב לפגיעה בלי להקטין אותה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך אני מרגיש כשלא מקשיבים לי?\n[כאן אני כותב]",
      "מה אני עושה עם הרגש הזה?\n[כאן אני כותב]",
      "מה הייתי בוחר/ת לשמוע אז?\n[כאן אני כותב]"
    ],
      [
      "איך אני מרגיש כשלא מקשיבים לי?\n[כאן אני כותב]",
      "מה אני עושה עם הרגש הזה?\n[כאן אני כותב]",
      "מה הייתי בוחר/ת לשמוע אז?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "פגיעה שלא נאמרת — נשארת בגוף."
    ],
      [
      "סגירה",
      "פגיעה שלא נאמרת — נשארת בגוף."
    ]
    ),
    action: localizedGenderNode(
      "יד על החזה + נשימה אחת כשעולה פגיעה.",
      "יד על החזה + נשימה אחת כשעולה פגיעה."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "פחד מדחייה",
    opening: localizedGenderNode(
      [
      "היום אני פוגש את הפחד שיגידו לי “לא”."
    ],
      [
      "היום אני פוגש את הפחד שיגידו לי “לא”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “דחייה היא אפשרות — לא גזר דין.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “דחייה היא אפשרות — לא גזר דין.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני מדמיין שיקרה אם יגידו לי “לא”?\n[כאן אני כותב]",
      "האם זה קרה בעבר — ומה באמת קרה אז?\n[כאן אני כותב]",
      "איזו אמת אני יכול לבחור גם אם יש “לא”?\n[כאן אני כותב]"
    ],
      [
      "מה אני מדמיין שיקרה אם יגידו לי “לא”?\n[כאן אני כותב]",
      "האם זה קרה בעבר — ומה באמת קרה אז?\n[כאן אני כותב]",
      "איזו אמת אני יכול לבחור גם אם יש “לא”?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני נשאר בעל ערך גם כשלא נענים לבקשה."
    ],
      [
      "סגירה",
      "אני נשאר בעל ערך גם כשלא נענים לבקשה."
    ]
    ),
    action: localizedGenderNode(
      "אני נושם דקה עם האפשרות של “לא”.",
      "אני נושם דקה עם האפשרות של “לא”."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "אחריות על הצרכים שלי",
    opening: localizedGenderNode(
      [
      "היום אני מפסיק לצפות שינחשו אותי."
    ],
      [
      "היום אני מפסיק לצפות שינחשו אותי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה צורך אני מחכה שיבינו לבד?\n[כאן אני כותב]",
      "איך זה מרגיש לחכות בלי לומר?\n[כאן אני כותב]",
      "מה צעד קטן של אחריות יכול להיות?\n[כאן אני כותב]"
    ],
      [
      "איזה צורך אני מחכה שיבינו לבד?\n[כאן אני כותב]",
      "איך זה מרגיש לחכות בלי לומר?\n[כאן אני כותב]",
      "מה צעד קטן של אחריות יכול להיות?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "לבטא צורך זו אחריות — לא חולשה."
    ],
      [
      "סגירה",
      "לבטא צורך זו אחריות — לא חולשה."
    ]
    ),
    action: localizedGenderNode(
      "אני מנסח צורך אחד במשפט פשוט.",
      "אני מנסח צורך אחד במשפט פשוט."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "ניסוח בגוף ראשון",
    opening: localizedGenderNode(
      [
      "היום אני מדבר בלי האשמה."
    ],
      [
      "היום אני מדבר בלי האשמה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך זה נשמע כשאני מאשים?\n[כאן אני כותב]",
      "איך אותו דבר נשמע בגוף ראשון (“אני מרגיש / אני בוחר/ת”)?\n[כאן אני כותב]",
      "איזו גרסה מרגישה לי בטוחה יותר?\n[כאן אני כותב]"
    ],
      [
      "איך זה נשמע כשאני מאשים?\n[כאן אני כותב]",
      "איך אותו דבר נשמע בגוף ראשון (“אני מרגיש / אני בוחר/ת”)?\n[כאן אני כותב]",
      "איזו גרסה מרגישה לי בטוחה יותר?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "גוף ראשון פותח הקשבה."
    ],
      [
      "סגירה",
      "גוף ראשון פותח הקשבה."
    ]
    ),
    action: localizedGenderNode(
      "אני מתרגל משפט אחד בגוף ראשון.",
      "אני מתרגל משפט אחד בגוף ראשון."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "מתי נכון לדבר",
    opening: localizedGenderNode(
      [
      "היום אני בוחר עיתוי שמכבד אותי."
    ],
      [
      "היום אני בוחר עיתוי שמכבד אותי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי אני מעלה צרכים בדרך כלל?\n[כאן אני כותב]",
      "איך זה משפיע על התגובה?\n[כאן אני כותב]",
      "מתי יהיה עיתוי קצת יותר בטוח?\n[כאן אני כותב]"
    ],
      [
      "מתי אני מעלה צרכים בדרך כלל?\n[כאן אני כותב]",
      "איך זה משפיע על התגובה?\n[כאן אני כותב]",
      "מתי יהיה עיתוי קצת יותר בטוח?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "עיתוי הוא חלק מהגבול."
    ],
      [
      "סגירה",
      "עיתוי הוא חלק מהגבול."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר זמן אחד עתידי לשיחה — בלי לבצע.",
      "אני בוחר זמן אחד עתידי לשיחה — בלי לבצע."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "לשאת אי־נוחות",
    opening: localizedGenderNode(
      [
      "היום אני נשאר עם חוסר נוחות רגע — בלי לסגת."
    ],
      [
      "היום אני נשאר עם חוסר נוחות רגע — בלי לסגת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הכי לא נוח לי בלבטא צורך?\n[כאן אני כותב]",
      "מה קורה אם אני נשאר עם זה דקה?\n[כאן אני כותב]",
      "מה למדתי על היכולת שלי לשאת את זה?\n[כאן אני כותב]"
    ],
      [
      "מה הכי לא נוח לי בלבטא צורך?\n[כאן אני כותב]",
      "מה קורה אם אני נשאר עם זה דקה?\n[כאן אני כותב]",
      "מה למדתי על היכולת שלי לשאת את זה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אי־נוחות היא זמנית. דיכוי הוא קבוע."
    ],
      [
      "סגירה",
      "אי־נוחות היא זמנית. דיכוי הוא קבוע."
    ]
    ),
    action: localizedGenderNode(
      "תרגול דקה אחת של נשימה עם אי־נוחות.",
      "תרגול דקה אחת של נשימה עם אי־נוחות."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "לבחור את עצמי בלי לאבד קשר",
    opening: localizedGenderNode(
      [
      "היום אני מבין שאפשר גם וגם."
    ],
      [
      "היום אני מבין שאפשר גם וגם."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה זה אומר לבחור בי בקשר?\n[כאן אני כותב]",
      "איזה ערך אני לא מוכן יותר לוותר עליו?\n[כאן אני כותב]",
      "איזו בקשה אחת מייצגת את הערך הזה?\n[כאן אני כותב]"
    ],
      [
      "מה זה אומר לבחור בי בקשר?\n[כאן אני כותב]",
      "איזה ערך אני לא מוכן יותר לוותר עליו?\n[כאן אני כותב]",
      "איזו בקשה אחת מייצגת את הערך הזה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "בחירה בעצמי יכולה להעמיק קשר."
    ],
      [
      "סגירה",
      "בחירה בעצמי יכולה להעמיק קשר."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב את הערך שלי ושומר אותו קרוב.",
      "אני כותב את הערך שלי ושומר אותו קרוב."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה רכה: קול שיש לו מקום",
    opening: localizedGenderNode(
      [
      "היום אני מסכם בלי לחץ לפעול מיד."
    ],
      [
      "היום אני מסכם בלי לחץ לפעול מיד."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “הקול שלי ראוי למקום.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “הקול שלי ראוי למקום.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על עצמי במסע הזה?\n[כאן אני כותב]",
      "מה נהיה לי ברור יותר?\n[כאן אני כותב]",
      "משפט חזרה לימים קשים (קצר וברור):\n[כאן אני כותב]"
    ],
      [
      "מה למדתי על עצמי במסע הזה?\n[כאן אני כותב]",
      "מה נהיה לי ברור יותר?\n[כאן אני כותב]",
      "משפט חזרה לימים קשים (קצר וברור):\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה סופית למסע",
      "אני לא רוצה לצעוק כדי להיות קיים.",
      "אני לא רוצה לשתוק כדי להיות אהוב.",
      "אני יכול לדבר — לאט, בכבוד, עם עצמי.",
      "וזה כוח."
    ],
      [
      "סגירה סופית למסע",
      "אני לא רוצה לצעוק כדי להיות קיים.",
      "אני לא רוצה לשתוק כדי להיות אהוב.",
      "אני יכול לדבר — לאט, בכבוד, עם עצמי.",
      "וזה כוח."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר צעד אחד קטן בעתיד שבו אתן קול לעצמי.",
      "אני בוחר צעד אחד קטן בעתיד שבו אתן קול לעצמי."
    ),
  },
].map(buildNormalizedDay);

export const difficultyExpressingNeedsAndBoundariesWithPartnerBlueprintHe = buildNormalizedPilotBlueprint({
  id: "difficulty_expressing_needs_and_boundaries_with_partner_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "difficulty_expressing_needs_and_boundaries_with_partner",
  category: "general",
  journeyName: {
    he: "קושי לבטא צרכים וגבולות מול בן/בת הזוג",
    en: "Difficulty Expressing Needs and Boundaries with a Partner",
    es: "Dificultad para expresar necesidades y límites en la pareja",
  },
  days,
});

export default difficultyExpressingNeedsAndBoundariesWithPartnerBlueprintHe;
